import React from "react";
import styled from "styled-components";
import { Chip } from "@mui/material";

type Tab = {
  label: string;
  count: number;
  selected: boolean;
  toggleUrl: string;
};

type Props = {
  tabs: Array<Tab> | undefined;
  handleSearch: (url: string) => void;
};

const Container = styled("div")`
  display: grid;
  grid-auto-flow: column;
  width: fit-content;
  gap: ${({ theme }) => theme.space.xsmall}px;

  ${({ theme }) => theme.breakpoints.up("lg")} {
    grid-auto-flow: row;
  }
`;

const StyledChip = styled(Chip)<{ selected: boolean }>`
  width: 100%;
  ${({ theme, selected }) =>
    selected
      ? `

  border-width: 2px;
  border-color: ${theme.colors.neutral};
`
      : ""}
`;

export const SearchTabs = ({ tabs, handleSearch }: Props) => {
  return (
    <Container>
      {false && <Chip color="default" variant="outlined" label="Sort By" />}
      {tabs?.map((tab) => {
        return (
          <StyledChip
            key={tab.label}
            selected={tab.selected}
            onClick={() => handleSearch(tab.toggleUrl)}
            variant="outlined"
            label={`${tab.label} (${tab.count})`}
          />
        );
      })}
    </Container>
  );
};
